// src/hooks/useAdSense.js
import { useEffect } from 'react';

const useAdSense = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
    script.async = true;
    script.onload = () => {
      (window.adsbygoogle = window.adsbygoogle || []).push({
        google_ad_client: 'ca-pub-8626961699894922',
        enable_page_level_ads: true,
      });
    };
    document.body.appendChild(script);
  }, []);
};


export default useAdSense;